import React from "react";
import Achievements from "../Achievements";

export default function AchievementsGridBlock({ id, type, ...content }) {
  return <Achievements content={content} />;
}
